function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 189.02,
  y1: 3.3853,
  x2: 17.3853,
  y2: 322.98,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 272.675,
  y1: 322.798,
  x2: 122.799,
  y2: 3.3251,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 287.5,
  y1: 324.5,
  x2: 2.50003,
  y2: 324.5,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 178.948,
  y1: 125.406,
  x2: 67.4059,
  y2: 323.051,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 136.659,
  y1: 322.843,
  x2: 104.844,
  y2: 257.341,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 207.5,
  y1: 188.5,
  x2: 90.5,
  y2: 188.5,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 199.5,
  y1: 168.5,
  x2: 100.5,
  y2: 168.5,
  stroke: "#075AB4",
  strokeWidth: 5,
  strokeLinecap: "round"
});

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 327,
    viewBox: "0 0 290 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.835215b4.svg";
export { ForwardRef as ReactComponent };